import { Heart, Download } from "lucide-react";
import { motion } from "framer-motion";
import { fileUrl } from "@/lib/api";

export const FreebieCard = ({ item, hearted, onToggleHeart, onDownload, index }) => (
  <motion.div
    data-testid={`freebie-card-${item.id}`}
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: Math.min(index * 0.06, 0.4) }}
  >
    <button
      type="button"
      data-testid={`download-image-${item.id}`}
      aria-label={`Download ${item.title}`}
      onClick={() => onDownload(item)}
      className="group block w-full overflow-hidden rounded-2xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink/40"
    >
      <img
        src={fileUrl(item.preview_url)}
        alt={item.title}
        loading={index > 3 ? "lazy" : "eager"}
        className="aspect-[2/1] w-full object-cover transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.04]"
      />
    </button>
    <div className="mt-2.5 flex items-start justify-between gap-1">
      <h3 className="font-serif text-[15px] font-medium leading-snug text-ink sm:text-lg">
        {item.title}
      </h3>
      <button
        type="button"
        data-testid={`heart-button-${item.id}`}
        aria-pressed={hearted}
        aria-label={hearted ? `Remove your heart from ${item.title}` : `Heart ${item.title}`}
        onClick={() => onToggleHeart(item.id)}
        className="-mr-2 -mt-1 flex min-h-[44px] min-w-[44px] items-center justify-center gap-1 rounded-full text-ink transition-transform duration-300 active:scale-90"
      >
        <Heart
          className={`h-[19px] w-[19px] transition-colors duration-300 ${
            hearted ? "text-[#C06A4E]" : "text-ink/70 hover:text-[#C06A4E]"
          }`}
          fill={hearted ? "#C06A4E" : "none"}
          strokeWidth={hearted ? 0 : 1.8}
        />
        <span
          data-testid={`heart-count-${item.id}`}
          className="text-[11px] font-medium tabular-nums text-ink/60"
        >
          {item.heart_count.toLocaleString()}
        </span>
      </button>
    </div>
    <button
      type="button"
      data-testid={`download-button-${item.id}`}
      onClick={() => onDownload(item)}
      className="mt-0.5 flex min-h-[36px] items-center gap-1.5 text-[11px] font-medium tracking-wide text-ink/55 transition-colors hover:text-ink sm:text-xs"
    >
      <Download className="h-3.5 w-3.5" />
      <span data-testid={`download-count-${item.id}`}>
        {item.download_count.toLocaleString()} downloads
      </span>
    </button>
  </motion.div>
);
